import React from 'react';
import { DefaultView } from '@plone/volto/components';
import PropTypes from 'prop-types';

const CompaniesView = props => {
    return (
        <>
            <DefaultView {...props} />
        </>
    );
};

CompaniesView.propTypes = {
    content: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default CompaniesView;